document.addEventListener("DOMContentLoaded", function () {
  var accordionCards = document.querySelectorAll(".accordionCard");

  accordionCards.forEach(function (card) {
    card.addEventListener("click", function () {
      // Toggle 'active' class on clicked card
      if (card.classList.contains('active')) {
        card.classList.remove('active');
      } else {
        card.classList.add('active');
      }
    });
    // Add active class to first card on load
    if (card === accordionCards[0]) {
      card.classList.add('active');
    }
  });
});
